var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ft"},[_c('dt',{staticClass:"lft"},[_c('img',{attrs:{"src":require("../assets/img/logoFt.png"),"alt":"同济大学退休办"}})])])
}]

export { render, staticRenderFns }